let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("w6Uy8")).then(() => parcelRequire('gLFT8'));